export default classNames => {
  return classNames
    .filter(className => className)
    .flatMap(className => className.split(' '));
};